const parseNumber = (numberLike, defaultValue = 0) => {
  if (typeof numberLike === "string") {
    numberLike = numberLike.replace(/['’]/g, "")
  }

  const parsedNumber = Number(numberLike)
  return Number.isNaN(parsedNumber) ? defaultValue : parsedNumber
}

const formatNumber = (number, options = {}, locale = "de-CH") =>
  number.toLocaleString(locale, options)

export { parseNumber, formatNumber }
